// extracted by mini-css-extract-plugin
module.exports = {"flex_no_wrap":"styles_flex_no_wrap__1vvft","canvasPrice":"styles_canvasPrice__vw932"};